class localStorageService {
    ls = window.localStorage

    setItem(key, value) {
        value = JSON.stringify(value)
        this.ls.setItem(key, value)
        return true
    }

    getItem(key) {
        let value = this.ls.getItem(key)
        try {
            console.log("key value",value)
            // return JSON.parse(value)
            return value
        } catch (e) {
            console.log(e)
            return null

        }
    }
}

export default new localStorageService()
